export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Expert Instructors',
      description: 'Learn from industry professionals with 10+ years of real-world experience'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Hands-On Projects',
      description: 'Build real-world projects and gain practical experience with live environments'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Schedule',
      description: 'Choose from weekday, weekend, or self-paced learning options'
    },
    {
      icon: 'ri-medal-line',
      title: 'Industry Certification',
      description: 'Earn recognized certifications to boost your career prospects'
    },
    {
      icon: 'ri-team-line',
      title: 'Career Support',
      description: 'Get job placement assistance and career guidance from our team'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Lifetime Access',
      description: 'Access course materials and updates forever, even after completion'
    }
  ];

  return (
    <section className="py-24 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
            Why Choose ProtectWize
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We provide more than just training - we build careers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group p-8 bg-gray-950 rounded-xl border border-gray-800 hover:border-teal-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/10"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-2xl text-gray-900`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}